import React, { useContext, useEffect, useState, useCallback } from "react";

import classes from "./Home.module.css";
import Button from "../UI/Button/Button";
import NewTodo from "../NewTodo/NewTodo";
import Todos from "../Todos/Todos";
import useHttp from "../hooks/use-http";
import AuthContext from "../../store/auth-context";

const Home = (props) => {
  const authCtx = useContext(AuthContext);
  const [todos, setTodos] = useState([]);

  const {
    isLoading,
    error,
    sendRequest: fetchTodos,  // pull out with alias

  } = useHttp();
  const { sendRequest: updateTodoRequest } = useHttp();
  const { sendRequest: deleteTodoRequest } = useHttp();

  useEffect(() => {
    const transformTodos = (todosData) => {
      let loadedTodos = [];
      if (Array.isArray(todosData)) {
        loadedTodos = todosData.map((todo) => ({
          id: todo.id,
          text: todo.text,
          done: todo.done,
          createDate: todo.createDate,
        }));
      }
      setTodos(loadedTodos);
    };

    fetchTodos(
      {
        url: "/todo/all",
      },
      transformTodos
    );
  }, []);

  const todoAddHandler = (todo) => {
    // Optimistic UI update
    setTodos((prevTodos) => prevTodos.concat(todo));
    setTimeout(() => {
      const token = localStorage.getItem("token");
      const headers = token ? { Authorization: "Bearer " + token } : {};
      fetch("/todo/all", { headers })
        .then(res => res.json())
        .then(todosData => {
          if (Array.isArray(todosData)) {
            const loadedTodos = todosData.map((t) => ({ id: t.id, text: t.text, done: t.done, createDate: t.createDate }));
            setTodos(loadedTodos);
          }
        })
        .catch(err => console.error("Background fetch error:", err));
    }, 1000);
  };

  const todoToggleHandler = (id, currentStatus) => {
    const targetTodo = todos.find(t => t.id === id);
    const updatedStatus = !currentStatus;

    // Optimistic UI update
    setTodos((prevTodos) =>
      prevTodos.map((todo) =>
        todo.id === id ? { ...todo, done: updatedStatus } : todo
      )
    );

    updateTodoRequest(
      {
        url: `/todo/${id}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: { ...targetTodo, done: updatedStatus },
      },
      () => { }
    );
  };

  const todoDeleteHandler = (id) => {
    deleteTodoRequest(
      {
        url: `/todo/delete/${id}`,
        method: "DELETE",
      },
      () => {
        // Remove locally after successful delete
        setTodos((prevTodos) => prevTodos.filter((todo) => todo.id !== id));
      }
    );
  };
  return (
    <React.Fragment>
      <NewTodo onAddTodo={todoAddHandler} />
      <Todos
        items={todos}
        loading={isLoading}
        error={error}
        onFetch={fetchTodos}
        onToggle={todoToggleHandler}
        onDelete={todoDeleteHandler}
      />
    </React.Fragment>
  );
};

export default Home;
